'use client'

import type { ReactNode } from 'react'
import { Label } from 'react-aria-components'

type SharedUILabelOwnProps = {
  inputId: string

  label: ReactNode

  /** Appends a required marker ("*") after the label */
  required?: boolean

  className?: string
}

/**
 * A component which must be re-used to display input labels.
 */
export function SharedUILabel({ inputId, label, required, className }: SharedUILabelOwnProps) {
  return (
    <Label htmlFor={inputId} className={className}>
      {label}
      {required && ' *'}
    </Label>
  )
}
